import { isEqual } from "@/utils/util";

import type { ChannelEmbedItem } from "@/interface/api";

export interface ChannelState {
  icon: string;
  pc: Omit<ChannelEmbedItem, "equipment">;
  wap: Omit<ChannelEmbedItem, "equipment">;
}

interface AddChannelState {
  _version: number;
}

class ChannelStateManager {
  private state: ChannelState & AddChannelState = {
    icon: "",
    pc: {
      embed_icon: "",
      embed_title: "",
      icon_color: "",
      position: "right_bottom",
      type: "icon",
      x: 0,
      y: 0,
    },
    wap: {
      embed_icon: "",
      embed_title: "",
      icon_color: "",
      position: "right_bottom",
      type: "icon",
      x: 0,
      y: 0,
    },
    _version: 0,
  };

  private listeners: Array<(state: ChannelState) => void> = [];

  constructor() {
    // 初始化 cookieId
    this.initializeCookieId();
  }

  private initializeCookieId(): void {
    // console.log(123);
  }

  get snapshot(): Readonly<ChannelState> {
    return Object.freeze({ ...this.state });
  }

  setState(
    update:
      | Partial<ChannelState>
      | ((prev: ChannelState) => Partial<ChannelState>),
    options: {
      emitEvent?: boolean;
      deepCompare?: boolean;
    } = {},
  ): void {
    const { emitEvent = true, deepCompare = false } = options;

    const newPartialState =
      typeof update === "function" ? update(this.state) : update;

    // 深度比较优化
    if (deepCompare && isEqual(this.state, newPartialState)) {
      return;
    }

    this.state = { ...this.state, ...newPartialState };
    this.state._version = (this.state._version || 0) + 1;

    if (emitEvent) {
      this.notifyListeners();
    }
  }

  subscribe(listener: (state: ChannelState) => void): () => void {
    this.listeners.push(listener);
    return () => {
      const index = this.listeners.indexOf(listener);
      if (index > -1) {
        this.listeners.splice(index, 1);
      }
    };
  }

  private notifyListeners(): void {
    this.listeners.forEach((listener) => listener(this.snapshot));
  }

  // 获取特定状态
  getState<K extends keyof ChannelState>(key: K): ChannelState[K] {
    return this.state[key];
  }

  // 批量更新状态
  batchUpdate(updates: Array<Partial<ChannelState>>): void {
    const finalUpdate = updates.reduce(
      (acc, update) => ({ ...acc, ...update }),
      {},
    );
    this.setState(finalUpdate);
  }
}

export { ChannelStateManager };
